import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CartDrawer from "@/components/cart/CartDrawer";
import SupportWidget from "@/components/support/SupportWidget";
import CookieConsent from "@/components/consent/CookieConsent";
import { organizationLd, websiteLd, localBusinessLd } from "@/lib/jsonld";

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-[var(--acx-bg)]">
      {/* Sitewide entity graph (rendered once on every route): Organization,
          WebSite (+ SearchAction) and LocalBusiness for SEO/GEO knowledge signals. */}
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(organizationLd())}</script>
        <script type="application/ld+json">{JSON.stringify(websiteLd())}</script>
        <script type="application/ld+json">{JSON.stringify(localBusinessLd())}</script>
      </Helmet>
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <SupportWidget />
      <CookieConsent />
    </div>
  );
};

export default Layout;
